import type { Dimension, MatrixFor } from "@src/math/types";
import { identity, multiply } from "@src/math/matrix";

export const MAX_RENDER_TRANSFORM_VALUE = 1e30;

export function canRenderTransform(values: readonly number[]): boolean {
  return values.every(
    (value) =>
      Number.isFinite(value) && Math.abs(value) <= MAX_RENDER_TRANSFORM_VALUE,
  );
}

export function canRenderMatrixSequence<D extends Dimension>(
  dimension: D,
  matrices: readonly Readonly<MatrixFor<D>>[],
): boolean {
  let accumulated = identity(dimension);
  for (const matrix of matrices.toReversed()) {
    try {
      accumulated = multiply(dimension, matrix, accumulated);
    } catch {
      return false;
    }
    if (!canRenderTransform(accumulated)) return false;
  }
  return true;
}
